module.exports = __webpack_public_path__ + "static/img/v5-2.e5836f9c.png";